module.exports = __webpack_public_path__ + "assets/img/ztoworld_logo.451c69d2.png";